import { fetchCarServiceLocationOptions } from "src/services/booking.service";
import { getTalksAboutUs } from "src/services/common.service";
import { fetchSpecialDeals } from "src/services/deals.service";
import { fetchPromotions } from "src/services/promotions.service";
import { fetchServices } from "src/services/services.service";

export const initialPage = async (): Promise<HomePageInitialState> => {
    const [
        carSearchLocationResponse,
        specialDealsResponse,
        promotionsResponse,
        servicesResponse,
    ] = await Promise.all([
        fetchCarServiceLocationOptions(),
        fetchSpecialDeals(),
        fetchPromotions({
            status: true,
            is_exclude_expired: true,
            limit: 5,
            offset: 0,
        }),
        fetchServices(),
    ]);

    return {
        locations: carSearchLocationResponse.success
            ? (carSearchLocationResponse.payload as CarSearchLocation[])
            : [],
        specialDeals: specialDealsResponse.success
            ? (specialDealsResponse.payload as Car[])
            : [],
        promotions: promotionsResponse.success
            ? (promotionsResponse.payload?.data as Promotion[])
            : [],
        services: servicesResponse.success
            ? (servicesResponse.payload as Service[])
            : [],
        talksAboutUsList: getTalksAboutUs(),
    };
};
